const REQUIRED_EXPECTED_ARRIVAL_COMPANY_IDS = new Set([
  "67c54941d01fd3b1d3d21530",
  "686becf5e5695daae65de088",
  "6710f00d365731c9d8b1bc77",
]);

export const isExpectedArrivalRequired = ({ status, companyId }) =>
  (status || "").toLowerCase() === "onthetrip" && REQUIRED_EXPECTED_ARRIVAL_COMPANY_IDS.has(companyId);

export const shouldBlockStatusChangeForMissingExpectedArrival = ({
  status,
  companyId,
  currentAddress,
}) =>
  isExpectedArrivalRequired({ status, companyId }) &&
  Boolean(currentAddress) &&
  !currentAddress.expectedUnloadingDate;
